import React, { Fragment } from 'react';
import { makeStyles, createStyles } from '@material-ui/core';
import {
	Toolbar,
	ToolbarButtonGroup,
	ToolbarInput,
	ToolbarMenu,
	Select,
	Option,
	UserInterfacePlusCircleOutline
} from 'neon-design-system';
import { ChannelSubscriberKind, freeClosedChannelSubscriberLabel, freeOpenChannelSubscriberLabel, premiumChannelSubscriberLabel } from '../../../shared/global-enums';
import { ChannelTypes } from '../../../shared/types';

const useStyles = makeStyles(theme => createStyles({
	headingCaption: {
		display: 'flex',
		justifyContent: 'space-between'
	},
	selectRange: {
		minWidth: theme.spacing(10),
		width: 284
	},
	toolbarWrapper: {
		display: 'flex',
		flexDirection: 'row',
		gap: theme.spacing(1)
	}
}));

function toOptions(map: Partial<{[x in ChannelSubscriberKind]: string}>): Option[] {
	return Object.keys(map).map(k => k as ChannelSubscriberKind).map(k => ({
		label: map[k] || '',
		value: k
	}));
}

export interface ChannelSubscribersFilterProps {
	channelType: ChannelTypes;
	searchString: string;
	channelSubscriberKind: ChannelSubscriberKind;
	onQueryStringChange: (value: string) => void;
	onSelectedKindChange: (value: ChannelSubscriberKind) => void;
	onAddNewSubscriber: () => void;
	onAddBulkNewSubscribers: () => void;
}

export const ChannelSubscribersFilter = (props: ChannelSubscribersFilterProps) => {
	const classes = useStyles();
	const options = toOptions(props.channelType === ChannelTypes.premium
		? premiumChannelSubscriberLabel
		: props.channelType === ChannelTypes.freeClosed
			? freeClosedChannelSubscriberLabel
			: freeOpenChannelSubscriberLabel
	);

	const handleRangeChange = (selected: Option) => {
		props.onSelectedKindChange(selected.value as ChannelSubscriberKind)
	}

	const handleAddSubscribersChange = (value: string | number) => {
		if (value === 'bulk') return props.onAddBulkNewSubscribers();
		return props.onAddNewSubscriber();
	}

	return (
		<Fragment>
			<div className={classes.headingCaption}>
				<Select
					size="medium"
					clearable={false}
					menuPlacement="auto"
					searchable={false}
					className={classes.selectRange}
					value={options.find(o => o.value === props.channelSubscriberKind)}
					onChange={(opt: Option): void => handleRangeChange(opt)}
					options={options}
				/>
				<div className={classes.toolbarWrapper}>
					<Toolbar id="channel-subscribers-toolbar">
						<ToolbarButtonGroup>
							<ToolbarInput
								id="channel-subscriber-toolbar-search"
								icon={'search'}
								placeholder="Type to search..."
								onChange={props.onQueryStringChange}
								value={props.searchString}
							/>
							<ToolbarMenu
								iconWithText={<UserInterfacePlusCircleOutline />}
								placeholder="Add subscribers"
								openToTheLeft
								onChange={handleAddSubscribersChange}
								items={[
									{
										title: 'Add manually',
										value: 'manual'
									},
									{
										title: 'Upload CSV',
										value: 'bulk'
									}
								]}
							/>
						</ToolbarButtonGroup>
					</Toolbar>
				</div>
			</div>
		</Fragment>
	);
};
